import { Construction } from 'lucide-react'

export default function TabStub({ name }) {
  return (
    <div style={{ padding: '60px 32px', textAlign: 'center', color: 'var(--text-muted)' }}>
      <Construction size={40} style={{ marginBottom: 16, opacity: 0.4 }} />
      <h2 style={{ fontSize: 22, color: 'var(--navy)', marginBottom: 8 }}>{name}</h2>
      <p style={{ fontSize: 14 }}>Coming in a future phase</p>
    </div>
  )
}
